import type { JSX, ReactNode } from "react";

type OnboardingPageTitleProps = {
  children: ReactNode;
};

export function OnboardingPageTitle({
  children,
}: OnboardingPageTitleProps): JSX.Element {
  return (
    <div className="flex h-7 items-center">
      <h1 className="m-0 font-serif text-xl leading-none tracking-tight">
        {children}
      </h1>
    </div>
  );
}
